import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as AuthActions } from "../store/ducks/auth";
import PrivateRoute from "../components/PrivateRoute";
import asyncComponent from "../components/AsyncComponent";

const Login = asyncComponent(() => import("../pages/Login"));
const IncorrectPath = asyncComponent(() => import("../pages/IncorrectPath"));
const Main = asyncComponent(() => import("../pages/Main"));
const Bancos = asyncComponent(() => import("../pages/Bancos"));
const Operacoes = asyncComponent(() => import("../pages/Operacoes"));
const OrigemVendas = asyncComponent(() => import("../pages/OrigemVendas"));
const Promotoras = asyncComponent(() => import("../pages/Promotoras"));
const Produtos = asyncComponent(() => import("../pages/Produtos"));
const Cargos = asyncComponent(() => import("../pages/Cargos"));
const TiposUsuarios = asyncComponent(() => import("../pages/TiposUsuarios"));
const StatusProposta = asyncComponent(() => import("../pages/StatusProposta"));
const TabelasConvenios = asyncComponent(() =>
  import("../pages/TabelasConvenios")
);
const Lojas = asyncComponent(() => import("../pages/Lojas"));
const Usuarios = asyncComponent(() => import("../pages/Usuarios"));
const Regioes = asyncComponent(() => import("../pages/Regioes"));
const GruposAcessos = asyncComponent(() => import("../pages/GruposAcessos"));
const Feriados = asyncComponent(() => import("../pages/Feriados"));
const Clientes = asyncComponent(() => import("../pages/Clientes"));
const Propostas = asyncComponent(() => import("../pages/Propostas"));
const Borderos = asyncComponent(() => import("../pages/Borderos"));
const Desempenho = asyncComponent(() => import("../pages/Desempenho"));
const Rankings = asyncComponent(() => import("../pages/Rankings"));
const ExtratoPago = asyncComponent(() => import("../pages/ExtratoPago"));
const GerarRepasses = asyncComponent(() => import("../pages/GerarRepasses"));
const PropostasAlertas = asyncComponent(() =>
  import("../pages/PropostasAlertas")
);
const Empresa = asyncComponent(() => import("../pages/Empresa"));
const Ajuda = asyncComponent(() => import("../pages/Ajuda"));
const MateriaisApoio = asyncComponent(() => import("../pages/MateriaisApoio"));
const Metas = asyncComponent(() => import("../pages/Metas"));
const RelatorioMetas = asyncComponent(() => import("../pages/RelatorioMetas"));
const Comunicados = asyncComponent(() => import("../pages/Comunicados"));
const StatusAtendimento = asyncComponent(() =>
  import("../pages/StatusAtendimento")
);
const FormasAtendimento = asyncComponent(() =>
  import("../pages/FormasAtendimento")
);
const BuscaClientes = asyncComponent(() => import("../pages/BuscaClientes"));
const RelatorioAtendimento = asyncComponent(() =>
  import("../pages/RelatorioAtendimento")
);
const Dashboard = asyncComponent(() => import("../pages/Dashboard"));
const Campanhas = asyncComponent(() => import("../pages/Campanhas"));
const ConsignadoInss = asyncComponent(() => import("../pages/ConsignadoInss"));
const DetalheClientePesquisador = asyncComponent(() =>
  import("../pages/DetalheClientePesquisador")
);
const DadosCadastrais = asyncComponent(() =>
  import("../pages/DadosCadastrais")
);
const DetalheClienteDados = asyncComponent(() =>
  import("../pages/DetalheClienteDados")
);
const DetalheClienteDadosCnpj = asyncComponent(() =>
  import("../pages/DetalheClienteDadosCnpj")
);
const DetalheClienteDadosRelacionadas = asyncComponent(() =>
  import("../pages/DetalheClienteDadosRelacionadas")
);
const Calendario = asyncComponent(() => import("../pages/Calendario"));
const Organograma = asyncComponent(() => import("../pages/Organograma"));
const CalendarioPesquisador = asyncComponent(() =>
  import("../pages/CalendarioPesquisador")
);
const CategoriasPagamentos = asyncComponent(() =>
  import("../pages/CategoriasPagamentos")
);
const CategoriasRecebimentos = asyncComponent(() =>
  import("../pages/CategoriasRecebimentos")
);
const MetodosPagamentos = asyncComponent(() =>
  import("../pages/MetodosPagamentos")
);
const Lancamentos = asyncComponent(() => import("../pages/Lancamentos"));
const GruposRepasses = asyncComponent(() => import("../pages/GruposRepasses"));
const Extrato = asyncComponent(() => import("../pages/Extrato"));
const ContasBancarias = asyncComponent(() =>
  import("../pages/ContasBancarias")
);
const ValoresDiario = asyncComponent(() => import("../pages/ValoresDiario"));
const CalendarioUsoPesquisador = asyncComponent(() =>
  import("../pages/CalendarioUsoPesquisador")
);
const Importacoes = asyncComponent(() => import("../pages/Importacoes"));
const CategoriasBonusDesconto = asyncComponent(() =>
  import("../pages/CategoriasBonusDesconto")
);
const BonusDesconto = asyncComponent(() => import("../pages/BonusDesconto"));

const Routes = ({ login }) => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={IncorrectPath} />
      <Route exact path="/:tenant" component={Login} />
      <PrivateRoute exact path="/:tenant/inicial" component={Main} />
      <PrivateRoute exact path="/:tenant/operacoes" component={Operacoes} />
      <PrivateRoute exact path="/:tenant/bancos" component={Bancos} />
      <PrivateRoute
        exact
        path="/:tenant/origem-da-venda"
        component={OrigemVendas}
      />
      <PrivateRoute exact path="/:tenant/promotoras" component={Promotoras} />
      <PrivateRoute exact path="/:tenant/produtos" component={Produtos} />
      <PrivateRoute exact path="/:tenant/cargos" component={Cargos} />
      <PrivateRoute
        exact
        path="/:tenant/tipos-de-usuario"
        component={TiposUsuarios}
      />
      <PrivateRoute
        exact
        path="/:tenant/status-de-proposta"
        component={StatusProposta}
      />
      <PrivateRoute
        exact
        path="/:tenant/tabelas-de-convenios"
        component={TabelasConvenios}
      />
      <PrivateRoute exact path="/:tenant/lojas" component={Lojas} />
      <PrivateRoute exact path="/:tenant/usuarios" component={Usuarios} />
      <PrivateRoute exact path="/:tenant/regioes" component={Regioes} />
      <PrivateRoute
        exact
        path="/:tenant/grupos-de-acessos"
        component={GruposAcessos}
      />
      <PrivateRoute exact path="/:tenant/feriados" component={Feriados} />
      <PrivateRoute exact path="/:tenant/clientes" component={Clientes} />
      <PrivateRoute exact path="/:tenant/propostas" component={Propostas} />
      <PrivateRoute exact path="/:tenant/borderos" component={Borderos} />
      <PrivateRoute exact path="/:tenant/desempenho" component={Desempenho} />
      <PrivateRoute exact path="/:tenant/rankings" component={Rankings} />
      <PrivateRoute
        exact
        path="/:tenant/extrato-pago"
        component={ExtratoPago}
      />
      <PrivateRoute
        exact
        path="/:tenant/gerar-repasses"
        component={GerarRepasses}
      />
      <PrivateRoute
        exact
        path="/:tenant/propostas-alertas"
        component={PropostasAlertas}
      />
      <PrivateRoute exact path="/:tenant/empresa" component={Empresa} />
      <PrivateRoute exact path="/:tenant/ajuda" component={Ajuda} />
      <PrivateRoute
        exact
        path="/:tenant/materiais-de-apoio"
        component={MateriaisApoio}
      />
      <PrivateRoute exact path="/:tenant/metas" component={Metas} />
      <PrivateRoute
        exact
        path="/:tenant/relatorio-metas"
        component={RelatorioMetas}
      />
      <PrivateRoute exact path="/:tenant/comunicados" component={Comunicados} />
      <PrivateRoute
        exact
        path="/:tenant/status-de-atendimento"
        component={StatusAtendimento}
      />
      <PrivateRoute
        exact
        path="/:tenant/formas-de-atendimento"
        component={FormasAtendimento}
      />
      <PrivateRoute
        exact
        path="/:tenant/central-de-atendimento"
        component={BuscaClientes}
      />
      <PrivateRoute
        exact
        path="/:tenant/relatorio-de-atendimento"
        component={RelatorioAtendimento}
      />
      <PrivateRoute exact path="/:tenant/dashboard" component={Dashboard} />
      <PrivateRoute exact path="/:tenant/campanhas" component={Campanhas} />
      <PrivateRoute
        exact
        path="/:tenant/consignado-inss"
        component={ConsignadoInss}
      />
      <PrivateRoute
        exact
        path="/:tenant/consignado-inss=:cpf"
        component={ConsignadoInss}
      />
      <PrivateRoute
        exact
        path="/:tenant/detalhe-cliente-pesquisador=:nb"
        component={DetalheClientePesquisador}
      />
      <PrivateRoute
        exact
        path="/:tenant/dados-cadastrais"
        component={DadosCadastrais}
      />
      <PrivateRoute
        exact
        path="/:tenant/detalhe-cliente-dados=:cpf"
        component={DetalheClienteDados}
      />
      <PrivateRoute
        exact
        path="/:tenant/detalhe-cliente-dados-cnpj=:cnpj"
        component={DetalheClienteDadosCnpj}
      />
      <PrivateRoute
        exact
        path="/:tenant/detalhe-cliente-dados-relacionadas=:relacionadas"
        component={DetalheClienteDadosRelacionadas}
      />
      <PrivateRoute exact path="/:tenant/calendario" component={Calendario} />
      <PrivateRoute exact path="/:tenant/organograma" component={Organograma} />
      <PrivateRoute
        exact
        path="/:tenant/calendario-pesquisador"
        component={CalendarioPesquisador}
      />
      <PrivateRoute
        exact
        path="/:tenant/categorias-de-pagamentos"
        component={CategoriasPagamentos}
      />
      <PrivateRoute
        exact
        path="/:tenant/categorias-de-recebimentos"
        component={CategoriasRecebimentos}
      />
      <PrivateRoute
        exact
        path="/:tenant/metodos-de-pagamentos"
        component={MetodosPagamentos}
      />
      <PrivateRoute exact path="/:tenant/lancamentos" component={Lancamentos} />
      <PrivateRoute
        exact
        path="/:tenant/grupos-de-repasses"
        component={GruposRepasses}
      />
      <PrivateRoute exact path="/:tenant/extrato" component={Extrato} />
      <PrivateRoute
        exact
        path="/:tenant/contas-bancarias"
        component={ContasBancarias}
      />
      <PrivateRoute
        exact
        path="/:tenant/valores-diarios"
        component={ValoresDiario}
      />
      <PrivateRoute
        exact
        path="/:tenant/calendario-uso-pesquisador"
        component={CalendarioUsoPesquisador}
      />
      <PrivateRoute exact path="/:tenant/importacoes" component={Importacoes} />
      <PrivateRoute
        exact
        path="/:tenant/categorias-bonus-desconto"
        component={CategoriasBonusDesconto}
      />
      <PrivateRoute
        exact
        path="/:tenant/bonus-desconto"
        component={BonusDesconto}
      />
    </Switch>
  </BrowserRouter>
);

const mapStateToProps = state => ({
  login: state.auth.login,
  pages: state.pages.currentPageName
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(AuthActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes);



// WEBPACK FOOTER //
// ./src/routes/index.js